import * as React from 'react'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'
import { NewsItemContentLoading } from '../component/NewsItemContent'
import { NewsItemHeaderLoading } from '../component/NewsItemHeader'

// todo: footer skeleton 없음.
const ScreenNewsItemFeedLoading: React.FC = () => {
  return (
    <StyledWrapper>
      <NewsItemHeaderLoading type="feed" />
      <NewsItemContentLoading type="feed" />
    </StyledWrapper>
  )
}

export default ScreenNewsItemFeedLoading

const StyledWrapper = styled.div`
  background-color: white;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  & > .hr {
    height: 1px;
    background-color: #e8e8e8;
    margin-bottom: 20px;
  }
  ${mobileBreakPoint} {
  }
`
